import React, { Component } from 'react';
import InputFieldComponent from './InputFieldComponent';
import { isValidBIC } from 'ibantools';
import { format as formatWith, length } from 'redux-form-validators';
import { BIC_MIN_LENGTH, BIC_MAX_LENGTH } from '../../constants/form';
import { BIC_REGEX } from '../../components/form/constants';
import format from 'string-template';

const normalizeBIC = value => value.toUpperCase();

class BICInputFieldComponent extends Component {
    isIbanValid = value =>
        value && isValidBIC(value) ? undefined : this.props.i18nFeatureForm.BIC_INVALID;

    validateMandatory = () => [
        length({
            max: BIC_MAX_LENGTH,
            min: BIC_MIN_LENGTH,
            msg: format(this.props.i18nFeatureForm.BIC_SIZE_ERROR, BIC_MIN_LENGTH, BIC_MAX_LENGTH)
        }),
        formatWith({
            with: BIC_REGEX,
            msg: this.props.i18nFeatureForm.INVALID_CHARACTERS
        }),
        this.isIbanValid
    ];

    render() {
        const { validate = [] } = this.props;
        return (
            <InputFieldComponent
                {...this.props}
                type="text"
                validate={[...this.validateMandatory(), ...validate]}
                maxLength={BIC_MAX_LENGTH}
                normalize={normalizeBIC}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js for global Field props
export default BICInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/BICInputFieldComponent.js